// ====================================================================
// CLIENT FOLLOW-UP CRM - SYSTEM SETTINGS VIEW
// ====================================================================

import { SUPABASE_CONFIG, saveSupabaseConfig } from '../config.js';
import { showToast } from '../ui.js';

export function renderSettingsView(container) {
  const isConnected = !!(SUPABASE_CONFIG.url && SUPABASE_CONFIG.anonKey);

  container.innerHTML = `
    <div class="page-header">
      <div>
        <h1 class="page-title">System & Database Settings</h1>
        <p class="page-subtitle">Configure Supabase PostgreSQL backend integration and system defaults</p>
      </div>
    </div>

    <div style="max-width: 680px;">
      <!-- Supabase Connection Box -->
      <div class="card">
        <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:1.25rem;">
          <h3 class="card-title">Supabase Database Credentials</h3>
          <span class="badge ${isConnected ? 'badge-upcoming' : 'badge-today'}">
            ${isConnected ? '● Connected to Supabase' : '○ Standalone Mock Mode'}
          </span>
        </div>

        <form id="settings-supabase-form">
          <div class="form-group">
            <label class="form-label">Supabase Project URL</label>
            <input type="url" id="cfg-url" class="form-control" placeholder="https://xyz.supabase.co" value="${SUPABASE_CONFIG.url}">
          </div>

          <div class="form-group">
            <label class="form-label">Supabase Anon API Key</label>
            <input type="password" id="cfg-key" class="form-control" placeholder="eyJh..." value="${SUPABASE_CONFIG.anonKey}">
          </div>

          <div style="display:flex; gap:0.75rem; justify-content:flex-end; margin-top:1.5rem;">
            <button type="button" id="btn-reset-supabase" class="btn btn-secondary">Clear & Use Mock Mode</button>
            <button type="submit" class="btn btn-primary">Save & Connect Supabase</button>
          </div>
        </form>
      </div>

      <!-- SQL Schema Instructions Card -->
      <div class="card">
        <h3 class="card-title" style="margin-bottom:0.5rem;">Database Schema setup</h3>
        <p style="font-size:0.875rem; color:var(--text-secondary); margin-bottom:1rem;">
          To initialize your Supabase tables and RLS security policies, copy and run the contents of <code>supabase_schema.sql</code> inside your Supabase SQL Editor.
        </p>
      </div>
    </div>
  `;

  document.getElementById('settings-supabase-form').addEventListener('submit', (e) => {
    e.preventDefault();
    const url = document.getElementById('cfg-url').value.trim();
    const key = document.getElementById('cfg-key').value.trim();
    saveSupabaseConfig(url, key);
    showToast('Supabase settings updated! Reloading application...', 'success');
  });

  document.getElementById('btn-reset-supabase').addEventListener('click', () => {
    saveSupabaseConfig('', '');
    showToast('Switched to Local Standalone Mock Mode!', 'info');
  });
}
